import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Container, Row, Col } from "reactstrap"

//Import Images
import error from "../../assets/images/error-img.png"
import { useAuthUserDetails } from "./getAuthUserDetails"
import { useDispatch } from "react-redux"

const unAuthorizedPage = () => {
   //meta title
  //  document.title = "401 Error Page | API Market Place - React Admin & Dashboard Template";
  // const [authDetails, setAuthDetails] = useState(null);
  const dispatch = useDispatch();
  const [dashboardPath, setDashboardPath] = useState("/dashboard"); 

  useEffect(() => {
      const authUserDetails = useAuthUserDetails();
      const landingpage = authUserDetails[0]?.landing_page;
      // setAuthDetails(authUserDetails[0])
      setDashboardPath(landingpage)
  }, [dispatch]);

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-5">
        <Container>
          <Row>
            <Col lg="12">
              <div className="text-center mb-5">
                <h1 className="display-2 font-weight-medium">
                  4<i className="bx bx-buoy bx-spin text-primary display-3" />
                  1
                </h1>
                <h4 className="text-uppercase">Unauthorized page</h4>
                <div className="mt-5 text-center">
                  <Link
                    className="btn btn-primary "
                    // to="/dashboard"
                    to={dashboardPath}
                  >
                    Back to Dashboard
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md="8" xl="6">
              <div>
                <img src={error} alt="" className="img-fluid" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default unAuthorizedPage
